/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ProfilePictureCacheService } from '@midas/shared/data-access';

@Component({
  selector: 'midas-profile-picture',
  templateUrl: './profile-picture.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatIconModule],
})
export class ProfilePictureComponent implements OnChanges {
  @Input() userId!: string;
  @Input() version: number | null = null;
  @Input() size = 24;
  @Input() fontSize = 24; // default icon uses font size which doesn't directly correlate with width/height

  imageUrl: string | null = null;

  constructor(
    private cdr: ChangeDetectorRef,
    private profilePictureCacheService: ProfilePictureCacheService,
  ) {}

  async ngOnChanges() {
    if (!this.userId && !this.version) {
      this.imageUrl = null;
      this.cdr.markForCheck();
    } else {
      this.profilePictureCacheService.getProfilePicture(this.userId, this.version).subscribe((imageUrl) => {
        this.imageUrl = imageUrl;
        this.cdr.markForCheck();
      });
    }
  }
}
